import ClickToCopyButton from './ClickToCopyButton';

export default ClickToCopyButton;
